import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import SelectPlan from './pages/SelectPlan';
import Dashboard from './pages/Dashboard';
import UnifiedDashboard from './pages/UnifiedDashboard';
import CustomerDashboard from './pages/CustomerDashboard';
import ContractClusterView from './pages/ContractClusterView';
import AcceptInvitation from './pages/AcceptInvitation';
import SybilDefenderDashboard from './pages/SybilDefenderDashboard';
import Pricing from './pages/Pricing';
import ApiDashboard from './pages/ApiDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import SmartDashboardRedirect from './components/SmartDashboardRedirect';

function App() {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    {/* Public routes */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/accept-invitation" element={<AcceptInvitation />} />
                    {/* Register is now admin-only */}
                    <Route
                        path="/register"
                        element={
                            <AdminRoute>
                                <Register />
                            </AdminRoute>
                        }
                    />
                    <Route path="/verify" element={<VerifyEmail />} />
                    <Route path="/sybil-dashboard" element={<SybilDefenderDashboard />} />
                    <Route path="/pricing" element={<Pricing />} />

                    {/* Protected routes */}
                    <Route
                        path="/select-plan"
                        element={
                            <ProtectedRoute>
                                <SelectPlan />
                            </ProtectedRoute>
                        }
                    />
                    {/* Customer Dashboard - for non-admin users with assigned contracts */}
                    <Route
                        path="/customer-dashboard"
                        element={
                            <ProtectedRoute requireVerified>
                                <CustomerDashboard />
                            </ProtectedRoute>
                        }
                    />
                    {/* Unified Dashboard - for admin users only */}
                    <Route
                        path="/unified-dashboard"
                        element={
                            <ProtectedRoute requireVerified>
                                <UnifiedDashboard />
                            </ProtectedRoute>
                        }
                    />
                    {/* Contract Cluster View - for both admin and customers */}
                    <Route
                        path="/contract-clusters/:contractAddress"
                        element={
                            <ProtectedRoute requireVerified>
                                <ContractClusterView />
                            </ProtectedRoute>
                        }
                    />
                    {/* Smart routes - automatically redirect to correct dashboard based on user role */}
                    <Route
                        path="/app"
                        element={
                            <ProtectedRoute requireVerified>
                                <SmartDashboardRedirect />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedRoute requireVerified>
                                <SmartDashboardRedirect />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/api-dashboard"
                        element={
                            <ProtectedRoute requireVerified>
                                <SmartDashboardRedirect />
                            </ProtectedRoute>
                        }
                    />

                    {/* Redirect unknown routes to login or app based on auth state */}
                    <Route path="*" element={<Navigate to="/login" replace />} />
                </Routes>
            </Router>
        </AuthProvider>
    );
}

export default App;

